/* unplugin-vue-components disabled */import script from "./preview-dialog.vue?vue&type=script&lang=jsx"
export * from "./preview-dialog.vue?vue&type=script&lang=jsx"

import "./preview-dialog.vue?vue&type=style&index=0&id=22090a28&lang=less&scoped=true"

import exportComponent from "/data/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22090a28"]])

export default __exports__